import { render, staticRenderFns } from "./DriverDataPage.vue?vue&type=template&id=4c49abc0&scoped=true&"
import script from "./DriverDataPage.vue?vue&type=script&lang=js&"
export * from "./DriverDataPage.vue?vue&type=script&lang=js&"
import style0 from "./DriverDataPage.vue?vue&type=style&index=0&id=4c49abc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49abc0",
  null
  
)

export default component.exports